'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/lib/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseButton = function CloseButton(_ref) {
  var onClick = _ref.onClick;
  return _react2.default.createElement(
    'button',
    { className: 'ec-share-panel__close-button', onClick: onClick },
    _react2.default.createElement(
      'span',
      { className: 'ec-share-panel__close-button-icon' },
      _react2.default.createElement(
        'svg',
        { focusable: 'false', viewBox: '0 0 32 32', width: '16', height: '16' },
        _react2.default.createElement('path', { d: 'M32 3.5L28.5 0 16 12.5 3.5 0 0 3.5 12.5 16 0 28.5 3.5 32 16 19.5 28.5 32l3.5-3.5L19.5 16' })
      )
    )
  );
};

CloseButton.propTypes = {
  onClick: _PropTypes2.default.func.isRequired
};

exports.default = CloseButton;